import { FormSection } from '../../components/ui/FormSection';

export interface SocialMediaValues {
  instagram: string;
  facebook: string;
  youtube: string;
  tiktok: string;
}

const SOCIAL_FIELDS = [
  { key: 'instagram', label: 'Instagram', placeholder: '@yourwinery or https://instagram.com/yourwinery' },
  { key: 'facebook', label: 'Facebook', placeholder: 'https://facebook.com/yourwinery' },
  { key: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@yourwinery' },
  { key: 'tiktok', label: 'TikTok', placeholder: '@yourwinery' },
] as const;

interface ContactInformationSectionProps {
  phone: string;
  onPhoneChange: (value: string) => void;
  email: string;
  onEmailChange: (value: string) => void;
  website: string;
  onWebsiteChange: (value: string) => void;
  socialMedia: SocialMediaValues;
  onSocialMediaChange: (key: keyof SocialMediaValues, value: string) => void;
}

export const ContactInformationSection = ({
  phone,
  onPhoneChange,
  email,
  onEmailChange,
  website,
  onWebsiteChange,
  socialMedia,
  onSocialMediaChange,
}: ContactInformationSectionProps) => (
  <FormSection title="Contact Information">
    <div>
      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
        Phone
      </label>
      <input
        type="tel"
        id="phone"
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      />
    </div>

    <div>
      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
        Email
      </label>
      <input
        type="email"
        id="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      />
    </div>

    <div>
      <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-1">
        Website
      </label>
      <input
        type="url"
        id="website"
        value={website}
        onChange={(e) => onWebsiteChange(e.target.value)}
        placeholder="https://example.com"
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      />
    </div>

    <div>
      <h3 className="text-sm font-medium text-gray-700 mb-2">Social Media</h3>
      <div className="space-y-4">
        {SOCIAL_FIELDS.map(({ key, label, placeholder }) => (
          <div key={key}>
            <label htmlFor={key} className="block text-sm text-gray-600 mb-1">
              {label}
            </label>
            <input
              type="text"
              id={key}
              value={socialMedia[key]}
              onChange={(e) => onSocialMediaChange(key, e.target.value)}
              placeholder={placeholder}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
            />
          </div>
        ))}
      </div>
    </div>
  </FormSection>
);
